import { defa }          from 'defa-object';
import { DateConverter } from 'scripts/utils/date-converter';
import ControlModel      from 'scripts/poppet/control-model';
/**
 * defa.models.Calendar
 * The DEFA Calendar model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );

const apiHost = defa.vars.apiHost;

const api = {
	linkcom: apiHost + '/linkcom/',
	calendar: '/homeAutomation/masterControl?attrs='
};

const Calendar = ControlModel.extend( {
	
	url: function() {
		return api.linkcom + this.get('id') + api.calendar + this.getAttributes();
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend({},ControlModel.prototype.defaults,
		{
			calendarEntries:[
			// {
			//          date: 'yyyy-mm-dd'
			//          time: 'hh:mm'
			//     		dateTime: '2019-04-20T10:20:00.000Z',
			//          mainSwitch  : 'Home' or 'Away',
			// }

			],
			calendarEntriesError: null,
			calendarEntriesDisabled: true,

			// maxCount The maximum number of calendarEntries
			maxCount: 6,
		}
	),
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	parse: function( response, options ) {
		if ( response && response.calendarEntries ) {
			let newModelAttributes = {};
			this.parseAttribute('calendarEntries', response.calendarEntries, options, newModelAttributes);
			if('success' === response.calendarEntries.status && newModelAttributes.calendarEntries) {
				newModelAttributes.calendarEntriesDisabled = false;
				let entries = newModelAttributes.calendarEntries;
				for ( let index in entries ) {
					let entry  = entries[ index ];
					let date   = new Date( entry.dateTime );
					entry.time = date.toTimeString().slice( 0, 5 );
					entry.date = date.format( 'yyyy-mm-dd' );
				}
			}
			newModelAttributes.modelError = null;
			this.receivedData( newModelAttributes );
			channel.request( 'calendars' ).add( newModelAttributes, { merge: true } );
		}
	},
	
	toBackendJSON() {
		//Set timeDate
		let backendModel = { calendarEntries: [], };
		backendModel.calendarEntries = this.get('calendarEntries');
		for(let index in backendModel.calendarEntries) {
			let entry = backendModel.calendarEntries[index];
			let dateObject = entry.date + 'T'+ entry.time + DateConverter.getTimezoneString(new Date());
			entry.dateTime = new Date(dateObject).toISOString();
		}
		return backendModel;
	},
	
	attributeToRequestPayload: function(attribute) {
		let backendModel = {};
		backendModel.calendarEntries = attribute;
		
		for(let index in backendModel.calendarEntries) {
			let entry = backendModel.calendarEntries[index];
			let dateObject = entry.date + 'T'+ entry.time + DateConverter.getTimezoneString(new Date());
			entry.dateTime = new Date(dateObject).toISOString();
		}
		
		return backendModel;
	},
	
	getAttributes: function() {
		return 'calendarEntries';
	},
	
} );

export default Calendar;
